import { Link } from 'react-router-dom';
import { useAuth } from '@/app/AuthContext';
import {
  HouseIcon,
  NeighborhoodsIcon,
  EmergencyIcon,
  ExploreIcon,
  FlightsIcon,
  MapIcon,
  CalendarIcon,
  ServicesIcon,
  HeartIcon,
  SettingsIcon,
  AdminIcon,
  AlertIcon,
  ChevronRightIcon,
} from '@/components/Icons';

const ITEMS = [
  { to: '/rental', label: 'Our Rental', icon: HouseIcon, description: 'Lease, Beth Stark, house info' },
  {
    to: '/neighborhoods',
    label: 'Neighborhoods',
    icon: NeighborhoodsIcon,
    description: 'Every Babcock Ranch neighborhood \u2014 prices, age, amenities, homes for sale',
  },
  {
    to: '/medical',
    label: 'Health & emergency',
    icon: EmergencyIcon,
    description: '911, ER, urgent care, primary care, pharmacy',
  },
  { to: '/prepare', label: 'Hurricane Prep', icon: AlertIcon, description: 'Checklist, evacuation zone, shelter, supplies' },
  { to: '/services', label: 'Home Services', icon: ServicesIcon, description: 'Plumbers, HVAC, pool, pest and more' },
  { to: '/explore', label: 'Explore', icon: ExploreIcon, description: 'Beaches and day trips' },
  { to: '/travel', label: 'Travel', icon: FlightsIcon, description: 'RSW, PGD, and regional airports' },
  { to: '/map', label: 'Map', icon: MapIcon, description: 'Ranch map' },
  { to: '/events', label: "What's On", icon: CalendarIcon, description: 'Town and Babcock National calendars' },
  { to: '/family-favorites', label: 'Family Favorites', icon: HeartIcon, description: 'Saved family favorites (hearts)' },
  { to: '/settings', label: 'Settings', icon: SettingsIcon, description: 'Session and app info' },
  { to: '/admin', label: 'Admin', icon: AdminIcon, description: 'Manage places, contacts, documents' },
];

export function MorePage() {
  const { logout } = useAuth();
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">More</h1>
      </div>
      <div className="card" style={{ padding: 0 }}>
        {ITEMS.map(({ to, label, icon: Icon, description }) => (
          <Link key={to} to={to} className="list-row" style={{ padding: '16px' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Icon />
              <span>
                <strong style={{ display: 'block' }}>{label}</strong>
                <small style={{ color: 'var(--color-ink-muted)' }}>{description}</small>
              </span>
            </span>
            <ChevronRightIcon />
          </Link>
        ))}
      </div>
      <button type="button" className="btn btn-danger btn-block" onClick={() => logout()}>
        Log Out
      </button>
    </div>
  );
}
